import clsx from 'clsx';
import { RadioGroup as BaseRadioGroup, Field, Label } from '@headlessui/react';

import { Radio, RadioColors } from './Radio';

export type Primitive = string | number | boolean;

export type RadioGroupOption<OptionValueType extends Primitive = string> = {
  label: string;
  value: OptionValueType;
};

type RadioGroupProps<OptionValueType extends Primitive = string> = {
  className?: string;
  color?: RadioColors;
  disabled?: boolean;
  label?: string;
  value: OptionValueType | undefined;
  onChange: (value: OptionValueType) => void;
  options: RadioGroupOption<OptionValueType>[];
};

export const RadioGroup = <OptionValueType extends Primitive = string>({
  className,
  color,
  disabled,
  label,
  value,
  onChange,
  options,
}: RadioGroupProps<OptionValueType>) => {
  return (
    <div className={clsx('space-y-3', className)}>
      {label && <div className="font-bold">{label}</div>}
      <BaseRadioGroup
        value={value}
        onChange={onChange}
        className="flex items-center gap-4"
      >
        {options.map((option) => (
          <Field key={String(option.value)} className="flex items-center gap-2">
            <Radio
              checked={option.value === value}
              color={color}
              disabled={disabled}
              value={option.value}
            ></Radio>
            <Label className="font-semibold cursor-pointer">
              {option.label}
            </Label>
          </Field>
        ))}
      </BaseRadioGroup>
    </div>
  );
};
